module.exports = function () {

    if ($('.card-grid-module').length === 0) {
        return;
    }    
        
    $('.card-grid-module__show-more-button').click(function () {        
        var $moduleContainer = $(this).closest('.card-grid-module__container');
        var $cardsContainer = $moduleContainer.find('.card-grid-module__cards-container');
        var $buttonContainer = $(this).closest('.card-grid-module__button-container');        
        var showMoreCardNumber = $buttonContainer.data('showMoreCardNumber');
        
        var $nextHiddenCards = $cardsContainer.find('.card-grid-module__card.hidden').slice(0, showMoreCardNumber);
        if ($nextHiddenCards.length) {
            $nextHiddenCards.removeClass('hidden');
            $buttonContainer.find('.card-grid-module__show-less-button').removeClass('hidden');
            var $remainingHiddenCards = $cardsContainer.find('.card-grid-module__card.hidden');
            if (!$remainingHiddenCards.length) {
                $(this).addClass('hidden');
            }
            window.scrollTo({ top: $nextHiddenCards.offset().top - 80, behavior: 'smooth' });            
        }        
    });

    $('.card-grid-module__show-less-button').click(function () {
        var $moduleContainer = $(this).closest('.card-grid-module__container');
        var $cardsContainer = $moduleContainer.find('.card-grid-module__cards-container');
        var $buttonContainer = $(this).closest('.card-grid-module__button-container');        
        var showMoreCardNumber = $buttonContainer.data('showMoreCardNumber');

        var hideStartPosition = 0;
        var hideableCardNumber = $cardsContainer.find('.card-grid-module__card--non-default:not(.hidden)').length;
        if (hideableCardNumber > showMoreCardNumber) {
            hideStartPosition = (Math.ceil(hideableCardNumber / showMoreCardNumber)-1) * showMoreCardNumber;
        }

        var $nextHideableCards = $cardsContainer.find('.card-grid-module__card--non-default:not(.hidden)').slice(hideStartPosition);
        if ($nextHideableCards.length) {
            $nextHideableCards.addClass('hidden');
            $buttonContainer.find('.card-grid-module__show-more-button').removeClass('hidden');

            var $remainingHideableCards = $cardsContainer.find('.card-grid-module__card--non-default:not(.hidden)');

            var scrollToElement = null;

            if (!$remainingHideableCards.length) {
                $(this).addClass('hidden');
                scrollToElement = $cardsContainer[0];
            }
            else {                
                scrollToElement = $remainingHideableCards.slice($remainingHideableCards.length - showMoreCardNumber)[0];
            }

            if (scrollToElement !== null) {
                window.scrollTo({ top: $(scrollToElement).offset().top - 80, behavior: 'smooth' });                
            }
        }        
    });

    var setCardGridHoverability = function () {
        window.cardGridHoverability = true;
        if (window.matchMedia('(hover: none)').matches) {
            window.cardGridHoverability = false;
        }
    }

    var hideCardOverlayContent = function (cardImageAreaElement) {
        $(cardImageAreaElement).find('.card-grid-module__card-overlay-content').attr('aria-hidden', 'true');
    }

    var revealCardOverlayContent = function (cardImageAreaElement) {
        $(cardImageAreaElement).find('.card-grid-module__card-overlay-content').removeAttr('aria-hidden');
    }

    var revealCardHiddenContent = function (cardImageAreaElement) {                   
        $(cardImageAreaElement).addClass('card-grid-module__card-image-area--hidden-content-revealed');
        $(cardImageAreaElement).find('.card-grid-module__card-hidden-content-container').removeAttr('aria-hidden');
        $(cardImageAreaElement).find('.card-grid-module__card-hidden-content-close').attr('tabindex', '');
        $(cardImageAreaElement).find('.card-grid-module__card-link-text').attr('tabindex', '');
    }
    
    var hideCardHiddenContent = function (cardImageAreaElement) {
        $(cardImageAreaElement).removeClass('card-grid-module__card-image-area--hidden-content-revealed');        

        if ($(cardImageAreaElement).hasClass('card-grid-module__card-image-area--toggled')) {
            $(cardImageAreaElement).removeClass('card-grid-module__card-image-area--toggled');
            var toggleIndicator = $(cardImageAreaElement).find('.card-grid-module__card-image-toggle-indicator').first();
            toggleIndicator.removeClass('card-grid-module__card-image-toggle-indicator--deactivated');
            toggleIndicator.focus();
        }

        $(cardImageAreaElement).find('.card-grid-module__card-hidden-content-container').attr('aria-hidden', 'true');
        $(cardImageAreaElement).find('.card-grid-module__card-hidden-content-close').attr('tabindex', '-1');
        $(cardImageAreaElement).find('.card-grid-module__card-link-text').attr('tabindex', '-1');
    }

    setCardGridHoverability();

    $('.card-grid-module__card-image-area').hover(
        function () {
            if (window.cardGridHoverability) {
                hideCardOverlayContent(this);
                revealCardHiddenContent(this);
            }
        },
        function () {
            if (window.cardGridHoverability) {
                hideCardHiddenContent(this);
                revealCardOverlayContent(this);
            }
        }
    );

    var setCardImageClickability = function () {
        if (!(window.cardGridHoverability)) {            
            $('.card-grid-module__card-image-area').addClass('card-grid-module__card-image-area--clickable');
        }
        else {            
            $('.card-grid-module__card-image-area').removeClass('card-grid-module__card-image-area--clickable');
        }
    }
    
    setCardImageClickability();
    
    $('.card-grid-module__card').on('click', '.card-grid-module__card-image-area--clickable:not(.card-grid-module__card-image-area--hidden-content-revealed)', function () {
        hideCardOverlayContent(this);
        revealCardHiddenContent(this);
    });
    
    $('.card-grid-module__card').on('click', '.card-grid-module__card-hidden-content-close', function () {
        var cardImageAreaElement = $(this).closest('.card-grid-module__card-image-area').first();
        hideCardHiddenContent(cardImageAreaElement);
        revealCardOverlayContent(cardImageAreaElement);
    });

    $('.card-grid-module__card').on('click', '.card-grid-module__card-image-toggle-indicator', function () {
        $(this).addClass('card-grid-module__card-image-toggle-indicator--deactivated');
        var cardImageAreaElement = $(this).closest('.card-grid-module__card-image-area').first();
        cardImageAreaElement.addClass('card-grid-module__card-image-area--toggled');
        hideCardOverlayContent(cardImageAreaElement);
        revealCardHiddenContent(cardImageAreaElement);
        cardImageAreaElement.find('.card-grid-module__card-hidden-content-close').first().focus();
    });    

    $(window).resize(function () {
        setCardGridHoverability();
        setCardImageClickability();
    });
};